<template>
  <span class="mobile-break"><br /></span>
</template>

<style>
.mobile-break {
  display: none;
}

@media (max-width: 640px) {
  .mobile-break {
    display: inline;
  }
}
</style>
